import { render, staticRenderFns } from "./lostpassword.vue?vue&type=template&id=ff7a6618"
import script from "./lostpassword.vue?vue&type=script&lang=js"
export * from "./lostpassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports